import { ShrimpTypeEnum } from "@gtpl/shared-models/common-models";
import { InvoiceStatusEnum } from "@gtpl/shared-models/masters";

// export class RmInvoiceUpdateReq{
//     grnId: number
//     billTo: number;
//     invStatus : InvoiceStatusEnum
//     invDate:any
//     grnItemsInfo : InvoiceRmItems[]
//     constructor(grnId: number,billTo: number,invStatus : InvoiceStatusEnum,invDate:any,grnItemsInfo : InvoiceRmItems[]){
//         this.grnId = grnId
//         this.billTo = billTo
//         this.invStatus = invStatus
//         this.invDate = invDate
//         this.grnItemsInfo = grnItemsInfo
//     }
// }

// export class InvoiceRmItems{
//     grnItemId : number;
//     actualPrice: number;
//     remarks: string;

//     constructor(grnItemId : number,actualPrice: number,remarks: string){
//         this.grnItemId = grnItemId
//         this.actualPrice = actualPrice
//         this.remarks = remarks
//     }
// }

export class RmInvoiceUpdateReq{
    grnId?:number
    billTo ?:string
    plantId?:number
    grnItemsInfo ?: InvoiceRmItems[]
    invoiceStatus ?: InvoiceStatusEnum
    billToType?:string;
    financierName?:string
    createdUser?:string
    constructor(grnId?:number,billTo ?:string,plantId?:number, grnItemsInfo?: InvoiceRmItems[],invoiceStatus ?: InvoiceStatusEnum, billToType?:string, financierName?:string,createdUser?:string){
        this.grnId = grnId
        this.billTo = billTo
        this.plantId = plantId
        this.grnItemsInfo = grnItemsInfo
        this.invoiceStatus = invoiceStatus
        this.billToType = billToType
    this.financierName = financierName
    this.createdUser = createdUser
    }
    
}

 export class InvoiceRmItems{
    batchNumber:string;
    grnId:number;
    grnItemId:number;
    defectId:number;
    invoiceDate: any;
    count:number;
    unitPrice : number;
    quantity: number;
    totalAmount : number;
    type:ShrimpTypeEnum;
    indentId:number;
    invoiceRemarks : string;
    

    constructor(batchNumber:string,grnId:number,grnItemId:number,defectId:number,invoiceDate: any,count:number,unitPrice : number,quantity: number,totalAmount : number,type:ShrimpTypeEnum,indentId:number,invoiceRemarks : string,billToType?: string, financierName?:string ){
    this.batchNumber = batchNumber
    this.grnId = grnId
    this.grnItemId = grnItemId
    this.defectId = defectId
    this.invoiceDate = invoiceDate
    this.count = count
    this.unitPrice  = unitPrice 
    this.quantity = quantity
    this.totalAmount  = totalAmount 
    this.type = type
    this.indentId = indentId
    this.invoiceRemarks  = invoiceRemarks 
    

    }
 }
